import { ReactNode } from "react";
import {
  cardContainer,
  descriptionContainer,
  imageContainer,
  nameContainer,
} from "./styles.css";

type PersonCardProps = {
  image: ReactNode;
  name: string;
  description: ReactNode;
};

export const PersonCard = ({ description, name, image }: PersonCardProps) => {
  return (
    <div className={cardContainer}>
      <div className={imageContainer}>{image}</div>
      <div className={nameContainer}>
        <p>{name}</p>
      </div>
      <div className={descriptionContainer}>
        <p>{description}</p>
      </div>
    </div>
  );
};
